/* eslint-disable no-console */
// Shared Klaviyo client-side API helper.
// Authenticates with the public company ID (Site ID) only via the `company_id`
// query param, which is set once on `window.klaviyoCompanyId` from
// Site Settings > Klaviyo (see _Layout.cshtml). NEVER use a private API key
// with these client endpoints.
// See https://developers.klaviyo.com/en/reference/create_client_event

const KLAVIYO_CLIENT_BASE = 'https://a.klaviyo.com/client';
const KLAVIYO_REVISION = '2026-04-15';

const REGISTERED_PRODUCT_METRIC = 'Registered Product';
const ORDERED_SWATCHES_METRIC = 'Ordered Swatches';

const getCompanyId = () => window.klaviyoCompanyId || '';

// Sends a client-side event to Klaviyo. The event payload also upserts the
// profile, so a single call records a trackable metric AND makes the person
// show up in Klaviyo for future communication.
const sendClientEvent = (metricName, profileAttributes, eventProperties = {}) => {
  const companyId = getCompanyId();
  if (!companyId) {
    console.warn(`Klaviyo company ID is not set; skipping "${metricName}" event.`);
    return Promise.resolve();
  }
  const url = `${KLAVIYO_CLIENT_BASE}/events/?company_id=${encodeURIComponent(companyId)}`;
  return fetch(url, {
    method: 'POST',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json',
      revision: KLAVIYO_REVISION,
    },
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          metric: {
            data: {
              type: 'metric',
              attributes: { name: metricName },
            },
          },
          properties: eventProperties,
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes,
            },
          },
        },
      },
    }),
  });
};

// Records a "Registered Product" event (replaces Drip's identify for product
// registration). Profile + properties are upserted in the same call.
const trackRegisteredProduct = (profileAttributes, eventProperties = {}) =>
  sendClientEvent(REGISTERED_PRODUCT_METRIC, profileAttributes, eventProperties);

// Records an "Ordered Swatches" event after a successful SwatchBox order.
const trackSwatchOrder = (profileAttributes, eventProperties = {}) =>
  sendClientEvent(ORDERED_SWATCHES_METRIC, profileAttributes, eventProperties);

export { trackRegisteredProduct, trackSwatchOrder };
/* eslint-enable no-console */
